import React, { useCallback } from 'react';
import { Wrapper } from '~/src/components/Popups/styled';

const EmptyPopupCallback = ({ isOpen, children, onClose }) => {
  const close = useCallback(() => {
    onClose();
  }, []);

  return (
    <Wrapper isOpen={isOpen} onClose={close}>
      {children}
    </Wrapper>
  );
};

export default EmptyPopupCallback;
